import { on } from 'delegated-events'

const teamToggler = document.querySelector('.team-toggler')

const fn = {
  init: () => {
    on('click', '[data-team-toggle]', fn.handleToggle)
    fn.checkUrlParam()
  },

  handleToggle: (e) => {
    const target = e.target.dataset.teamToggle
    const groups = document.querySelectorAll('.team-group')

    teamToggler.querySelectorAll('button').forEach((x) => x.classList.remove('btn-fill'))
    teamToggler.querySelector(`button[data-team-toggle="${target}"]`).classList.add('btn-fill')

    if (target === 'all') {
      groups.forEach((x) => (x.style.display = 'block'))
    } else {
      groups.forEach((x) => (x.style.display = 'none'))

      document.querySelector(target).style.display = 'block'
    }
  },

  checkUrlParam: () => {
    const urlParams = new URLSearchParams(window.location.search)
    const team = urlParams.get('team')
    if (team){
      const groupSection = team + '-members'
      const buttonSelectedClass = 'button.' + groupSection;
      const groups = document.querySelectorAll('.team-group')

      teamToggler.querySelectorAll('button').forEach((x) => x.classList.remove('btn-fill'))
      teamToggler.querySelector(buttonSelectedClass).classList.add('btn-fill')

      groups.forEach((x) => (x.style.display = 'none'))
      document.querySelector(`#${groupSection}`).style.display = 'block'
    }
  }
}

export default {
  can: () => teamToggler,
  run: fn.init,
}
